import { render, staticRenderFns } from "./Gallerie.vue?vue&type=template&id=0bd56837&scoped=true&"
import script from "./Gallerie.vue?vue&type=script&lang=js&"
export * from "./Gallerie.vue?vue&type=script&lang=js&"
import style0 from "./Gallerie.vue?vue&type=style&index=0&id=0bd56837&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd56837",
  null
  
)

export default component.exports